import { format } from 'date-fns'

export const browserCurrentDateTime = () => {
  const now = new Date()
  const dateTime = format(now, 'EEEE, yyyy-MM-dd h:mm a')
  const timeZoneName = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'long',
  })
    .formatToParts(now)
    .find(part => part.type === 'timeZoneName')?.value

  return `${dateTime} ${timeZoneName}`
}

// https://phrase.com/blog/posts/detecting-a-users-locale/
export const browserLocales = (options = {}) => {
  const defaultOptions = {
    languageCodeOnly: false,
  }
  const opt = {
    ...defaultOptions,
    ...options,
  }
  const browserLocales =
    navigator.languages === undefined ? [navigator.language] : navigator.languages
  if (!browserLocales) {
    return undefined
  }
  return browserLocales.map(locale => {
    const trimmedLocale = locale.trim()
    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale
  })
}
